export default "__VITE_ASSET__BFOtjtLf__"